import * as VeeValidate from 'vee-validate'
import * as VeeRules from 'vee-validate/dist/rules'
import Validator from '05-ui-kit/lib/Validator'

Validator(VeeValidate, VeeRules)
